import React from 'react';
import { EndIcon, Separator, StartIcon, TextElement } from './text.styles.js';
const InterspersedText = ({ interspersedText = [], separator = React.createElement(React.Fragment, null, "\u2022"), }) => (React.createElement(React.Fragment, null, interspersedText?.length <= 1
    ? interspersedText
    : interspersedText?.map((text, index, array) => {
        const isLast = index === array.length - 1;
        return (React.createElement(React.Fragment, { key: index },
            text,
            !isLast && React.createElement(Separator, { "aria-hidden": true }, separator)));
    })));
function _Text({ elementType = 'span', startIcon, endIcon, fontSize, children, interspersedText, separator, ...rest }, ref) {
    return (React.createElement(TextElement, { ref: ref, as: elementType, startIcon: startIcon, endIcon: endIcon, fontSize: fontSize, hasContent: !!React.Children.count(children || interspersedText), ...rest },
        React.createElement(StartIcon, { iconName: startIcon, fontSize: fontSize }),
        interspersedText ? (React.createElement(InterspersedText, { interspersedText: interspersedText, separator: separator })) : (children),
        React.createElement(EndIcon, { iconName: endIcon, fontSize: fontSize })));
}
export const Text = React.forwardRef(_Text);
//# sourceMappingURL=text.component.js.map